import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
	return {
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
